import { ContentType } from "./enums";
import { TeaserEntry } from "./interfaces";
import { getLinkObjectFromTeaser } from "./link";

export function getPianoPlusOfferId() {
  return process.env.NEXT_PUBLIC_PIANO_PAID_OFFER_ID ?? '';
}

export function getPianoPlusTemplateId(){
  if(window.startInAppPurchase instanceof Function) {
    return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_TEMPLATE_ID ?? '';
  }
  return process.env.NEXT_PUBLIC_PIANO_PAID_TEMPLATE_ID ?? '';
}

export function getPianoPlusResourceId() {
  return process.env.NEXT_PUBLIC_PIANO_PAID_R_ID ?? '';
}

export function getPianoPurOfferId() {
  return process.env.NEXT_PUBLIC_PIANO_PUR_OFFER_ID ?? '';
}

export function getPianoPurTemplateId(){
  if(window.startInAppPurchase instanceof Function) {
    return process.env.NEXT_PUBLIC_PIANO_IAP_PUR_TEMPLATE_ID ?? '';
  }
  else if(window.startInAppPurchaseAndroid instanceof Function) {
    return process.env.NEXT_PUBLIC_PIANO_PUR_TEMPLATE_ANDROID_IAP_ID ?? '';
  }
  return process.env.NEXT_PUBLIC_PIANO_PUR_TEMPLATE_ID ?? '';
}

export function getPianoPurResourceId() {
  return process.env.NEXT_PUBLIC_PIANO_PUR_R_ID ?? '';
}

export function getPianoVideoExperienceId() {
  if(window.startInAppPurchase instanceof Function) {
    return process.env.NEXT_PUBLIC_PIANO_VIDEO_EXPERIENCE_ID ?? '';
  }
  return process.env.NEXT_PUBLIC_PIANO_VIDEO_EXPERIENCE_ID_ANDROID ?? '';
}

export function getPianoVideoTemplateId() {
  if(window.startInAppPurchase instanceof Function) {
    return process.env.NEXT_PUBLIC_PIANO_VIDEO_TEMPLATE_ID ?? '';
  }
  return process.env.NEXT_PUBLIC_PIANO_VIDEO_TEMPLATE_ID_ANDROID ?? '';
}

export function getPianoAid() {
  return process.env.NEXT_PUBLIC_PIANO_AID ?? '';
}

export function getPianoScriptUrl() {
  return process.env.NEXT_PUBLIC_PIANO_SCRIPT_URL ?? '';
}

export function getPianoIapPlusMonthlyProductId(): string {
  return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_MONTHLY_PRODUCT_ID ?? ''
}

export function getPianoIapPlusHalfYearProductId(): string {
  return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_HALFYEAR_PRODUCT_ID ?? ''
}

export function getPianoIapPlusYearlyProductId(): string {
  return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_YEARLY_PRODUCT_ID ?? ''
}

export function getPianoIapPurProductId(): string {
  return process.env.NEXT_PUBLIC_PIANO_IAP_PUR_PRODUCT_ID ?? ''
}

export function getPianoIapPlusMonthlyProductIdAndroid() {
  return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_MONTHLY_PRODUCT_ID_ANDROID
}

export function getPianoIapPlusHalfYearProductIdAndroid() {
  return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_HALFYEAR_PRODUCT_ID_ANDROID
}

export function getPianoIapPlusYearlyProductIdAndroid() {
  return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_YEARLY_PRODUCT_ID_ANDROID
}

export function getPianoIapPurProductIdAndroid() {
  return process.env.NEXT_PUBLIC_PIANO_IAP_PUR_PRODUCT_ID_ANDROID
}

export function getIApTermsId(termId: string) {
  // console.log(termId + " = " + process.env.NEXT_PUBLIC_PIANO_IAP_PAID_MONTHLY_TERM_ID + " -> " + (process.env.NEXT_PUBLIC_PIANO_IAP_PAID_MONTHLY_TERM_ID == termId) + " -> " + getPianoIapPlusMonthlyProductId())
  // console.log(termId + " = " + process.env.NEXT_PUBLIC_PIANO_IAP_PAID_HALFYEAR_TERM_ID + " -> " + (process.env.NEXT_PUBLIC_PIANO_IAP_PAID_HALFYEAR_TERM_ID == termId) + " -> " + getPianoIapPlusHalfYearProductId())
  // console.log(termId + " = " + process.env.NEXT_PUBLIC_PIANO_IAP_PAID_YEARLY_TERM_ID + " -> " + (process.env.NEXT_PUBLIC_PIANO_IAP_PAID_YEARLY_TERM_ID == termId) + " -> " + getPianoIapPlusYearlyProductId())
  // console.log(termId + " = " + process.env.NEXT_PUBLIC_PIANO_IAP_PUR_TERM_ID + " -> " + (process.env.NEXT_PUBLIC_PIANO_IAP_PUR_TERM_ID == termId) + " -> " + getPianoIapPurProductId())
  switch (termId) {
    case process.env.NEXT_PUBLIC_PIANO_IAP_PAID_MONTHLY_TERM_ID:
      return getPianoIapPlusMonthlyProductId();
      break;
    case process.env.NEXT_PUBLIC_PIANO_IAP_PAID_HALFYEAR_TERM_ID:
      return getPianoIapPlusHalfYearProductId();
      break;
    case process.env.NEXT_PUBLIC_PIANO_IAP_PAID_YEARLY_TERM_ID:
      return getPianoIapPlusYearlyProductId();
      break;
    case process.env.NEXT_PUBLIC_PIANO_IAP_PUR_TERM_ID:
      return getPianoIapPurProductId();
      break;
  }
  return ""
}

export function getIApTermsIdAndroid(termId: string) {
  switch (termId) {
    case process.env.NEXT_PUBLIC_PIANO_IAP_PAID_MONTHLY_TERM_ID_ANDROID:
      return getPianoIapPlusMonthlyProductIdAndroid();
      break;
    case process.env.NEXT_PUBLIC_PIANO_IAP_PAID_HALFYEAR_TERM_ID_ANDROID:
      return getPianoIapPlusHalfYearProductIdAndroid();
      break;
    case process.env.NEXT_PUBLIC_PIANO_IAP_PAID_YEARLY_TERM_ID_ANDROID:
      return getPianoIapPlusYearlyProductIdAndroid();
      break;
    case process.env.NEXT_PUBLIC_PIANO_IAP_PUR_TERM_ID_ANDROID:
      return getPianoIapPurProductIdAndroid();
      break;
  }
  return ""
}

export function getTermIdFromAndroidProductId(productId: string) {

    switch (productId) {
    case getPianoIapPlusMonthlyProductIdAndroid():
      return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_MONTHLY_TERM_ID_ANDROID;
      break;
  case getPianoIapPlusHalfYearProductIdAndroid():
    return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_HALFYEAR_TERM_ID_ANDROID;
    break;
  case getPianoIapPlusYearlyProductIdAndroid():
    return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_YEARLY_TERM_ID_ANDROID;
    break;
  case getPianoIapPurProductIdAndroid():
    return process.env.NEXT_PUBLIC_PIANO_IAP_PUR_TERM_ID_ANDROID;
    break;
  }
  return ""
}

export function getTermIdFromIApId(iApId: string) {
  // console.log(termId + " = " + process.env.NEXT_PUBLIC_PIANO_IAP_PAID_MONTHLY_TERM_ID + " -> " + (process.env.NEXT_PUBLIC_PIANO_IAP_PAID_MONTHLY_TERM_ID == termId) + " -> " + getPianoIapPlusMonthlyProductId())
  // console.log(termId + " = " + process.env.NEXT_PUBLIC_PIANO_IAP_PAID_HALFYEAR_TERM_ID + " -> " + (process.env.NEXT_PUBLIC_PIANO_IAP_PAID_HALFYEAR_TERM_ID == termId) + " -> " + getPianoIapPlusHalfYearProductId())
  // console.log(termId + " = " + process.env.NEXT_PUBLIC_PIANO_IAP_PAID_YEARLY_TERM_ID + " -> " + (process.env.NEXT_PUBLIC_PIANO_IAP_PAID_YEARLY_TERM_ID == termId) + " -> " + getPianoIapPlusYearlyProductId())
  // console.log(termId + " = " + process.env.NEXT_PUBLIC_PIANO_IAP_PUR_TERM_ID + " -> " + (process.env.NEXT_PUBLIC_PIANO_IAP_PUR_TERM_ID == termId) + " -> " + getPianoIapPurProductId())
  switch (iApId) {
    case process.env.NEXT_PUBLIC_PIANO_IAP_PAID_MONTHLY_PRODUCT_ID:
      return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_MONTHLY_TERM_ID ?? '';
      break;
    case process.env.NEXT_PUBLIC_PIANO_IAP_PAID_HALFYEAR_PRODUCT_ID:
      return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_HALFYEAR_TERM_ID ?? '';
      break;
    case process.env.NEXT_PUBLIC_PIANO_IAP_PAID_YEARLY_PRODUCT_ID:
      return process.env.NEXT_PUBLIC_PIANO_IAP_PAID_YEARLY_TERM_ID ?? '';
      break;
    case process.env.NEXT_PUBLIC_PIANO_IAP_PUR_PRODUCT_ID:
      return process.env.NEXT_PUBLIC_PIANO_IAP_PUR_TERM_ID ?? '';
      break;
  }
  return ""
}


export function getTermsUrl() {
  return `${process.env.NEXT_PUBLIC_VNP_BASE_URL}/agb`;
}

export function getCoopUrl() {
  return `${process.env.NEXT_PUBLIC_VNP_BASE_URL}/koop`;
}

export function getDataUrl() {
  return `${process.env.NEXT_PUBLIC_VNP_BASE_URL}/datenschutz`;
}

export function getOutbrainInstallationKey(){
  if(window.startInAppPurchase instanceof Function) {
    return process.env.NEXT_PUBLIC_OUTBRAIN_KEY_IOS ?? ''
  }
  return process.env.NEXT_PUBLIC_OUTBRAIN_KEY_ANDROID ?? ''
}

export function getOutbrainWidgetId(){
  if(window.startInAppPurchase instanceof Function) {
    return process.env.NEXT_PUBLIC_OUTBRAIN_WIDGET_ID_IOS ?? ''
  }
  return process.env.NEXT_PUBLIC_OUTBRAIN_WIDGET_ID_ANDROID ?? ''
}

export function getLinkForBreakingNews(teaser: TeaserEntry){
  const linkObject = getLinkObjectFromTeaser(teaser)
  if(linkObject?.internalLink) {
    return linkObject.internalLink
  }
  else if(linkObject?.externalLink) {
    return linkObject.externalLink
  }
  
  if(teaser.type == ContentType.Landingpage || teaser.type == ContentType.Ressort) {
    return `/ressort/${teaser.id}`
  }
  return `/article/${teaser.id}`
}

export function getV2ArticlePath(articleId: string) {
  return `/v2/article/${articleId}`
}

export function getV2ArticleUrl(articleId: string) {
  return `${process.env.NEXT_PUBLIC_BACKEND_URL}${getV2ArticlePath(articleId)}`
}

export function getV2RessortPath(ressortId: string) {
  return `/v2/ressort/${ressortId}`
}

export function getV2RessortUrl(ressortId: string) {
  return `${process.env.NEXT_PUBLIC_BACKEND_URL}${getV2RessortPath(ressortId)}`
}

export function getV2HomePath() {
  const homeRessortId = process.env.NEXT_PUBLIC_HOME_RESSORT ?? "";
  if(homeRessortId) {
    return getV2RessortPath(homeRessortId)
  }
  return "/"
}

export function getV2NavigationPath() {
  return `/v2/navigation`
}

export function getV2UserPath() {
  return `/v2/user`
}

export function getV2UserEditPath() {
  return `/v2/user/edit`
}


export function getV2SearchPath(searchText: string, sort: string, page: number) {
  return `/v2/search?query=${searchText}&sort=${sort}&page=${page}`
}